import React, { useState, useEffect } from "react";
import axios from "axios";

import { getUser, getIdToken, getClient } from "../../../../utils/storage";
import InnerLoader from "../../../InnerLoader";
import { fetchTotalMMResponses } from "../../../../services/dashboard-api";

const RespondentsSummary = (props) => {
  const [numberOfRespondents, setNumberOfRespondents] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  console.log("props", getClient()?.client.clientRef);

  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_total_client_request_respondents`,
  //       {
  //         uid: getUser().uid,
  //         idToken: getIdToken(),
  //         clientRef: getClient().clientRef,
  //       },
  //       { headers: { "content-type": "application/json" } }
  //     )
  //     .then(({ data }) => {
  //       setIsLoading(false);
  //       setNumberOfRespondents(data.totalNumberOfClientRequestRespondents);
  //     })
  //     .catch((error) => {
  //       console.log("Error getting total respondents", error);
  //     });
  // }, []);

  useEffect(() => {
    const getTotalRespondents = async () => {
      try {
        setIsLoading(true);

        const { data } = await fetchTotalMMResponses(
          getClient()?.client.clientRef
        );

        setNumberOfRespondents(
          data?.totalNumberOfClientRequestRespondents ?? 0
        );
      } catch (error) {
        console.log("Error getting total respondents", error);
      } finally {
        setIsLoading(false);
      }
    };

    getTotalRespondents();
  }, []);

  return (
    <div className="card-section padded expand">
      {isLoading ? (
        <InnerLoader />
      ) : (
        <>
          <div className="data huge">{numberOfRespondents}</div>
          <h3 className="move-down">Respondents</h3>
        </>
      )}
    </div>
  );
};

export default RespondentsSummary;
